import { __read } from "tslib";
import { useEffect } from 'react';
import { useTransitionState } from './useTransitionState';
var useHasMounted = function () {
    var _a = __read(useTransitionState(false), 2), hasMounted = _a[0], setHasMounted = _a[1];
    useEffect(function () {
        setHasMounted(true);
    }, [setHasMounted]);
    return hasMounted;
};
export { useHasMounted };
